import { FreeTextContainer } from "./style";

const FormFreeText = ({ flag, setFlag }) => {
  return (  
    <FreeTextContainer value={""} onChange={(e) => setFlag(e.target.value)} placeholder="Write your answer here..."></FreeTextContainer>
  );
}
 
export default FormFreeText;
